var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_146_987)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.74219 9.81563C5.74219 11.9765 6.60065 14.0489 8.12873 15.5769C9.6568 17.1049 11.7293 17.9633 13.8903 17.9633C16.0514 17.9633 18.1239 17.1049 19.652 15.5769C21.18 14.0489 22.0385 11.9765 22.0385 9.81563C22.0385 7.65474 21.18 5.58235 19.652 4.05436C18.1239 2.52638 16.0514 1.66797 13.8903 1.66797C11.7293 1.66797 9.6568 2.52638 8.12873 4.05436C6.60065 5.58235 5.74219 7.65474 5.74219 9.81563Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.66797 38.3348V34.2609C1.66797 32.1 2.52643 30.0277 4.05451 28.4997C5.58258 26.9717 7.6551 26.1133 9.81612 26.1133H17.9643C20.1253 26.1133 22.1978 26.9717 23.7259 28.4997C25.254 30.0277 26.1124 32.1 26.1124 34.2609V38.3348",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1523 1.93359C29.905 2.38233 31.4585 3.4016 32.5679 4.83072C33.6773 6.25984 34.2794 8.01751 34.2794 9.82664C34.2794 11.6358 33.6773 13.3934 32.5679 14.8226C31.4585 16.2517 29.905 17.271 28.1523 17.7197",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3338 38.3339V34.2601C38.3234 32.4618 37.7184 30.7175 36.613 29.299C35.5076 27.8805 33.964 26.8675 32.2227 26.418",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_146_987"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsers);
export default __webpack_public_path__ + "static/media/icon_users.28247e430a52175e62381ede153250e5.svg";
export { ForwardRef as ReactComponent };